import {BaSeButton, BaSeInput} from "@base/react";
import {toast} from "react-toastify";
import ToastContent from "../toastContent";
import ShareDetailsPopup from "./share-details-popup";
import ApiShare from "../../services/share";
import {useEffect, useMemo, useState} from "react";
import Loading from "../loading";
import {getUsersWithPlanner} from "../../mocks/helpers";
import {eventTag} from "../../services/utils";
import './index.scss'

const apiShare = ApiShare();

const SharePlanning = ({ data, isPlanner, event, postCredit = false }) => {
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState('');

  const plannerData = useMemo(() => {
    if (!data?.planner) return null;

    return {
      name: data.planner.name_planner || '',
      role: 'Planejador',
    };
  }, [data?.planner]);

  const allUsers = useMemo(() => {
    return getUsersWithPlanner(data.invites, plannerData);
  }, [data.invites, plannerData]);

  useEffect(() => {
    setLoading(true);

    const request = postCredit
      ? apiShare.sharePlanningPostCredit(data.id)
      : apiShare.sharePlanning(data.id);

    request
      .then((response) => {
        setContent(response.data);
        eventTag(event?.name, "atendimento", "submit", `Ativando compartilhamento: ${data?.title}`);
      })
      .catch(() => {
        toast.error(
          <ToastContent
            description="Não foi possível acessar essas informações no momento. Tente novamente mais tarde."
            title="Erro!"
          />
        )
      })
      .finally(() => {
        setLoading(false);
      });

    // eslint-disable-next-line
  }, [data.id, postCredit]);

  const shareLink = `${window.location.origin}/${postCredit ? 'compartilhar/pos-credito' : 'compartilhar'}/${content.token}`

  return (
    loading ? <Loading loading={loading} /> : (
      <div className="share-planning">
        <div className="share-planning-link">
          <BaSeInput
            value={shareLink}
            isReadOnly
            color="#B6BFC8"
          />
          <BaSeButton
            onClick={() => {
              navigator.clipboard.writeText(shareLink);
              toast.success(
                <ToastContent
                  description="Link copiado para a área de transferência!"
                  title="Sucesso!"
                />
              )
              eventTag(event?.name, "atendimento", event?.action, `Copiar link: ${data?.title}`);
            }}
            type="primary"
            value="Copiar link"
            leftIcon="link"
            color="#2E5DE6"
          />
        </div>
        {data.isShared && allUsers.length > 0 && (
          <ShareDetailsPopup 
            users={allUsers} 
            onClose={() => {}} 
            modal 
            isPlanner={isPlanner}
            event={event}
          />
        )}
      </div>
    )
  );
}

export default SharePlanning;
